import { Center, Spinner, Text } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import OperationsTable from 'presentation/components/modules/operations/OperationsTable';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading, {
  GridHeadingTrailingLink,
} from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';

interface Props {
  gridHeadingLink?: GridHeadingTrailingLink;
}

const PortfolioOperationsContainer: FC<Props> = ({ gridHeadingLink }) => {
  const { t } = useTranslation();

  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  let wrapByCard = true;
  let content;
  if (data) {
    if (data.operations.length > 0) {
      content = (
        <AppCard
          p="20px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <OperationsTable items={data.operations} />
        </AppCard>
      );
      wrapByCard = false;
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <>
      <GridHeading trailingLink={gridHeadingLink}>
        {t('operations')}
      </GridHeading>
      {content}
    </>
  );
};

export default PortfolioOperationsContainer;
